// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3yXWh","left":"StickyBox_left__2RT9X","right":"StickyBox_right__uWo7E"};